import { GetUsers } from '../../Repository/UserManagementRepository';
import * as userManagementActions from './UserManagementActionTypes';

// Action creator to fetch users data
export const GetUsersDataAction = () => {
    return async (dispatch)=>{
        const Data = await GetUsers();   // Fetch users data using repository function
        dispatch({type:userManagementActions.GetUsersDataType, payload:Data});  // Dispatch action with fetched data
    }
}